import React from "react";
import Helmet from "react-helmet";
import XGSIcon from "../../ui-components/icon/xgsIcon";
import XGSIcons from "../../ui-components/icon/xgsIcons";

const ATTRIBUTES = [
  { label: "Fast", icon: XGSIcons.faBolt },
  { label: "Simple", icon: XGSIcons.faCheck },
  { label: "Secure", icon: XGSIcons.faShieldAlt },
  { label: "No account required", icon: XGSIcons.faCreditCard },
];

const QuickPayHeader: React.FC = () => (
  <header className="xgs-public-payment__brand">
    <Helmet title="Quick Pay" />
    <div className="xgs-public-payment__brand-inner">
      <h1 className="xgs-public-payment__header">Quick Pay</h1>
      <p className="xgs-public-payment__intro">
        Make a fast and secure payment using your XGS probill number. No account required.
      </p>
      <ul className="xgs-public-payment__attributes">
        {ATTRIBUTES.map((item) => (
          <li key={item.label}>
            <XGSIcon icon={item.icon} />
            <span>{item.label}</span>
          </li>
        ))}
      </ul>
    </div>
  </header>
);

export default QuickPayHeader;
